import { asString, isValueNotEmpty, loadedDefinedMapWithDefault } from "common/components/component-helpers";
import { ActionSource } from "common/components/computation-types";
import { getLocalizedString } from "common/components/localization";
import { LOADING } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { ImagePickerSourceHint } from "generator/components/image-picker-types";
import { useForce } from "hooks/use-force";
import { useNetworkStatus } from "hooks/use-network-status";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";
import { useForceValueProducers } from "hooks/use-value-producers";
import { FilePickerWithUploadState } from "./file-picker-material-renderer";

export const ImagePickerMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [
        [valuePV, onChangeValue, isEnabledValue, , caption, isRequiredValue, cameraHintPV],
        [valueProducer, , , validFlag],
    ] = useForceValueProducers(getValueProducers, force, ctx);
    const { onClick: onChangeCB } = useOnClickFromAction(onChangeValue, ActionSource.ImagePicker, ctx, env);
    const onLine = useNetworkStatus();

    if (valuePV === LOADING || caption === LOADING) {
        return env.renderProgress();
    }

    const isEnabled = onLine && (onChangeCB === undefined || isEnabledValue !== false);
    const isRequired = isRequiredValue === true;

    const cameraHint = loadedDefinedMapWithDefault(
        cameraHintPV,
        ImagePickerSourceHint.Any,
        i => asString(i) as ImagePickerSourceHint
    );

    let value = "";
    if (valuePV !== undefined) {
        value = asString(valuePV);
    }

    let captionString = "";
    if (caption !== undefined) {
        captionString = asString(caption);
    }

    if (isRequired && isValueNotEmpty(value) !== true && validFlag !== undefined) {
        validFlag.set(false);
    }

    return (
        <FilePickerWithUploadState
            ctx={ctx}
            env={env}
            valuePV={valuePV}
            onChangeValue={onChangeCB !== undefined ? () => onChangeCB(undefined) : undefined}
            valueProducer={valueProducer}
            validFlag={validFlag}
            isRequired={isRequired}
            isEnabled={isEnabled}
            showPreview={true}
            caption={captionString}
            iconSource={"tt-player-camera"}
            deleteModalTitle={getLocalizedString("areYouSureYouWantToDeleteThisImage", env.appEnvironment.appKind)}
            mimePattern={"image/*"}
            valueLabel={getLocalizedString("chooseAnImage", env.appEnvironment.appKind)}
            capture={cameraHint === ImagePickerSourceHint.CameraOnly ? "environment" : undefined}
        />
    );
};
